'use client';

import Script from 'next/script';
import { useEffect } from 'react';
import { useAuth } from '@/hooks/useAuth';

declare global {
  interface Window {
    snaptr?: (...args: unknown[]) => void;
  }
}

const SNAP_PIXEL_ID = process.env.NEXT_PUBLIC_SNAP_PIXEL_ID;

/**
 * Base Snap Pixel script (page view tracking on every page) plus
 * Advanced Matching: re-inits with user_email only once a logged-in
 * user is known, so anonymous visitors are never sent an email.
 */
export function SnapPixel() {
  const { user } = useAuth();

  useEffect(() => {
    if (!SNAP_PIXEL_ID || !user?.email || typeof window.snaptr !== 'function') {
      return;
    }
    window.snaptr('init', SNAP_PIXEL_ID, { user_email: user.email });
  }, [user?.email]);

  if (!SNAP_PIXEL_ID) {
    return null;
  }

  return (
    <Script
      id="snap-pixel"
      strategy="afterInteractive"
      dangerouslySetInnerHTML={{
        __html: `
          (function(e,t,n){if(e.snaptr)return;var a=e.snaptr=function(){
          a.handleRequest?a.handleRequest.apply(a,arguments):a.queue.push(arguments)};
          a.queue=[];var s='script';var r=t.createElement(s);r.async=!0;
          r.src=n;var u=t.getElementsByTagName(s)[0];
          u.parentNode.insertBefore(r,u);})(window,document,
          'https://sc-static.net/scevent.min.js');

          snaptr('init', '${SNAP_PIXEL_ID}');
          snaptr('track', 'PAGE_VIEW');
        `,
      }}
    />
  );
}
